<template>
  <td :class="[td.class, tdAlign, rowClass ]" :width="td.with ? td.width : 'auto'">
    <div class="col-td d-flex ">
      <div class="multi-select d-inline" v-if="multiSelect && colIndex === 0">
        <input type="checkbox" v-model="checked" @change="onChange"/>
      </div>
      <div id="#render"></div>
      <div  v-if="!header.colTemplate" v-html="td"></div>
      <div v-else>
        <component :is="component" v-bind="{data: cell, header: header}" v-if="component"></component>
      </div>
    </div>
  </td>
</template>

<script>
import { mapGetters } from 'vuex'
import moment from "moment";

export default {
  name: 'Row',
  props: ['data', 'headers', 'align', 'rowClass', 'header', 'cell', 'multiSelect', 'rowIndex', 'colIndex', 'selected'],
  data() {
    return {
      td: this.data ? this.data : [],
      templateRender: null,
      child_component: null,
      checked: this.selected ?? false,
      row: this.cell ?? {},
    }
  },
  computed: {
    ...mapGetters({
      getDefaultDateFormat: 'settings/getDefaultDateFormat',
    }),
    tdAlign() {
      if(this.align) {
        switch(this.align) {
          case 'center':
            return 'text-center';
          case 'left':
            return 'text-left'
            case 'right':
              return 'text-right'
          default:
            return 'text-left';
        }
      }
    },
    component() {
      return this.header.colTemplate(this.cell) ?? null;
    },
  },
  methods: {
    onChange(e) {
      this.$emit('onChange', e);
    }
  },
  watch: {
    data: {
      handler: function(newVal) {
        if(!this.header.colTemplate && (this.header?.colType == 'date' || this.header?.colType == 'dateTime')) {
            const date = moment(newVal);
            if (date.isValid()) {
              this.td = date.format(this.getDefaultDateFormat + (this.header?.colType == 'dateTime' ? ' HH:mm' : ''));
            } else {
              this.td = newVal;
            }

            //load checkbox if checked
          this.checked = this.td.selected ?? false;

        } else {
          this.td = newVal;
        }
      },
      deep: true,
      immediate: true,
    },
    cell: {
      handler: function(newVal) {
        this.row = newVal;
        this.checked = this.row.selected ?? false;
      },
      deep: true,
      immediate: true,
    },
    checked: {
      handler: function (newVal) {
        this.$emit('onRowSelected', {
          rowIndex: this.rowIndex,
          colIndex: this.colIndex,
          cell: this.td,
          row: this.row,
          selected: newVal,
        });
      },
      deep: true,
    }
  }
}
</script>
